<template>
  <v-container grid-list-md fluid>
    <v-layout wrap justify-center align-center>
      <v-flex xs12>
        <span class="display-1">Compartilhamento de Pessoas</span>
      </v-flex>
      <v-flex xs12 sm8>
        <v-btn color="primary" :disabled="!pessoa.isOwner" @click="refreshEmpresas(2)" class="mb-4">
          {{ this.translate("system.button.add.title") }}
          <v-icon dark>{{ this.translate("system.button.add.icon") }}</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm4>
        <v-text-field append-icon="search" label="Pesquisar" v-model="search"></v-text-field>
      </v-flex>

      <!--Index-->
      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search"
          class="elevation-1"
          :rows-per-page-items="[100, 50, 25, { text: 'Todos', value: -1 }]"
          rows-per-page-text="Registros por página"
          no-data-text="Não existem registros"
          no-results-text="Nenhum registro encontrado"
        >
          <template slot="items" slot-scope="props">
            <td>
              <v-tooltip top v-if="props.item.ativo">
                <v-btn slot="activator" icon class="mx-0" style="cursor: default">
                  <v-icon color="green">lock_open</v-icon>
                </v-btn>
                <span>Acesso Liberado</span>
              </v-tooltip>
              <v-tooltip top v-else>
                <v-btn slot="activator" icon class="mx-0" style="cursor: default">
                  <v-icon color="red">lock</v-icon>
                </v-btn>
                <span>Acesso Bloqueado</span>
              </v-tooltip>
              {{ props.item.empresa.id_texto }}
            </td>
            <!--            <td>-->
            <!--              <v-checkbox-->
            <!--                      v-model="props.item.ativo" color="primary"-->
            <!--                      @click.native="editValue(entity, props.item.id, props.item)"-->
            <!--              ></v-checkbox>-->
            <!--            </td>-->
            <td align="center">
              <!-- <v-btn :disabled="!pessoa.isOwner" icon class="mx-0" @click="refreshEmpresas(3 ,props.item)">
                <v-icon color="teal">edit</v-icon>
              </v-btn> -->
              <v-btn :disabled="!pessoa.isOwner" icon class="mx-0" @click="deleteItem(props.item)">
                <v-icon color="pink">delete</v-icon>
              </v-btn>
            </td>
          </template>
          <template slot="pageText" slot-scope="props">
            {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>

    <!--Create Edit-->
    <v-dialog v-model="dialog" max-width="1600px" persistent>
      <v-card>
        <v-card-text>
          <v-container grid-list-md fluid>
            <v-layout wrap justify-center align-center>
              <v-flex xs12>
                <span class="display-1">Compartilhamento de Pessoas</span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                  :label="translate('table.' + entity + '.field.empresa_id')"
                  item-text="id_texto"
                  item-value="id"
                  v-model="editedItem.empresa_id"
                  :items="dynamicEmpresas"
                  name="empresa_id"
                  :error-messages="errors.collect('empresa_id')"
                  v-validate="'required'"
                  :data-vv-as="translate('table.' + entity + '.field.empresa_id')"
                ></v-autocomplete>
              </v-flex>
              <!--              <v-flex xs12>-->
              <!--                <v-switch color="primary" :label="translate('table.' + entity + '.field.ativo')"-->
              <!--                          v-model="editedItem.ativo"></v-switch>-->
              <!--              </v-flex>-->
              <v-flex xs12>
                <v-btn class="mx-1" color="primary darken-2" :disabled="saving" :loading="saving" @click.native="save()">Salvar</v-btn>
                <v-btn class="mx-1" @click.native="close(400)">Cancelar</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
tr td:last-child {
  min-width: 130px;
}
</style>

<script>
import crud from "./../../mixin/crud";

export default {
  mixins: [crud],
  data: () => ({
    entity: "pessoa_empresa",
    items: [],
    dynamicEmpresas: [],
  }),
  name: "Empresa",
  props: ["pessoa", "values", "empresas"],
  created() {
    this.items = this.values;
    this.editedItem = { ativo: false, empresa_id: "", pessoa_id: this.pessoa.id };
    this.defaultItem = { ativo: false, empresa_id: "", pessoa_id: this.pessoa.id };
  },
  methods: {
    refreshEmpresas(tela, obj = {}) {
      let remove;
      switch (tela) {
        case 2:
          this.create();
          remove = this.items.map((a) => a.empresa_id);
          remove.push(this.$auth.user().empresa_id);
          break;
        case 3: {
          this.editItem(obj);
          remove = this.items.map((a) => {
            if (a.empresa_id !== this.editedItem.empresa_id) {
              return a.empresa_id;
            }
          });
          remove.push(this.$auth.user().empresa_id);
          break;
        }
      }
      this.dynamicEmpresas = this.empresas.filter((item) => !remove.includes(item.id));
    },
  },
  computed: {
    headers: function () {
      return [
        { text: this.translate("table." + this.entity + ".field.empresa_id"), value: "empresa_id" },
        // { text: this.translate('table.' + this.entity + '.field.ativo'), value: 'ativo', width: '5%' },
        {
          text: this.translate("system.table.action"),
          value: "action",
          sortable: false,
          align: "center",
        },
      ];
    },
    // computedEmpresas () {
    //   let remove = this.items.map(a => {
    //   //   if (a.empresa_id != this.beforeEditedItem.empresa_id)
    //       return a.empresa_id
    //   })
    //
    //   var empresas = this.empresas.filter(item => !remove.includes(item.id))
    //
    //   return empresas
    // }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/details/Empresa.vue